import useStrings from "../../../localization/useStrings"
import SimplePaywallStep from "../SimplePaywallStep/SimplePaywallStep"
import styles from "./FreeDaysPaywallStep.module.scss"

const FreeDaysPaywallStep = () => {
  const strings = useStrings().multistep.subtitle

  return (
    <SimplePaywallStep>
      <div className={styles.container}>
        <label className={styles.title}>{strings.line1}</label>
        <label className={styles.titleAlt}>{strings.line2}</label>
        <label className={styles.title}>{strings.line3}</label>
      </div>
    </SimplePaywallStep>
  )
}

export default FreeDaysPaywallStep
